import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    countries: [],
    states: [],
    selectedCountry: String(),
    selectedState: String(),
    error: null,
    loading: false
}

export const getStates = createAsyncThunk(
    "reference/states",
    async ({countryCode, locale}) => {
        const stateUrl = "/reference/states/" + countryCode + "/" + locale;
        try {
            const response = await wtyReportApi.get(stateUrl, undefined);
            if (response.status !== 200) {
                new Error("Calling api to get states failed.");
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const getCountries = createAsyncThunk(
    "reference/countries",
    async ({locale}) => {
        const countryUrl = "/reference/countries/" + locale;
        try {
            const response = await wtyReportApi.get(countryUrl, undefined);
            if (response.status !== 200) {
                new Error("Calling api to get countries failed.");
            }
            return await response.data;
        } catch (error) {
            throw error;
        }
    }
)

const referenceSlice = createSlice({
    name: "reference",
    initialState,
    reducers: {
        setSelectedCountry: (state, action) => {
            state.selectedCountry = action.payload;
        },
        setSelectedState: (state, action) => {
            state.selectedState = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getCountries.pending, state => {
                state.loading = true;
                state.countries = [];
                state.error = null;
            })
            .addCase(getCountries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.countries = [];
            })
            .addCase(getCountries.fulfilled, (state, action) => {
                state.loading = true;
                state.countries = action.payload
                state.error = null;
            })
            .addCase(getStates.pending, state => {
                state.loading = true;
                state.states = [];
                state.error = null;
            })
            .addCase(getStates.rejected, (state, action) => {
                state.loading = false;
                state.states = [];
                state.error = action.payload;
            })
            .addCase(getStates.fulfilled, (state, action) => {
                state.loading = true;
                state.states = action.payload;
                state.error = null;
            })
    }
})

export const {setSelectedCountry, setSelectedState} = referenceSlice.actions
export const states = state => state.references.states
export const countries = state => state.references.countries

export default referenceSlice.reducer